export function throttle<T extends unknown[]>(fn: (...args: T) => void, delay: number) {
  let lastCalled = 0;
  return function dropOrCall(...args: T) {
    const now = Date.now();
    if (now - lastCalled < delay) {
      return undefined;
    }
    lastCalled = now;
    return fn(...args);
  };
}
